import {
  ApprovalWorkflowTemplateControllerDeleteTemplateParams,
  ApprovalWorkflowTemplateControllerGetParams,
  ApprovalWorkflowTemplateControllerListParams,
  CreateAWTemplateDto,
  RequestParams,
  UpdateAWTemplateDto
} from '@api/Api';
import { apiClient } from '@api/client';

export const approvalWorkflowTemplateControllerList = (
  data: ApprovalWorkflowTemplateControllerListParams,
  params: RequestParams = {}
) => apiClient.awTemplate.approvalWorkflowTemplateControllerList(data, params);

export const approvalWorkflowTemplateControllerCreateTemplate = (
  data: CreateAWTemplateDto
) =>
  apiClient.awTemplate.approvalWorkflowTemplateControllerCreateTemplate(data);

export const approvalWorkflowTemplateControllerDeleteTemplate = (
  params: ApprovalWorkflowTemplateControllerDeleteTemplateParams
) =>
  apiClient.awTemplate.approvalWorkflowTemplateControllerDeleteTemplate(params);

export const approvalWorkflowTemplateControllerGet = (
  data: ApprovalWorkflowTemplateControllerGetParams,
  params: RequestParams = {}
) => apiClient.awTemplate.approvalWorkflowTemplateControllerGet(data, params);

export const approvalWorkflowTemplateControllerUpdateTemplate = (
  params: UpdateAWTemplateDto
) =>
  apiClient.awTemplate.approvalWorkflowTemplateControllerUpdateTemplate(params);
